var render = function render(){var _vm=this,_c=_vm._self._c;return _c('title-cover',{staticClass:"w-50"},[_c('p',{staticClass:"dv-title"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }